unit Essentials.Web.CustomNames.Editor;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WebForm.Core, WEBLib.Lists,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls, WEBLib.Controls,
  WEBLib.Dialogs, Data.DB, WEBLib.DB, Essentials.Web.BaseEditForm, Grid.Plugins,
  WEBLib.ExtCtrls, Web, WebLib.WebCtrls,   XData.Web.Connection,
  XData.Web.Client, Types, XData.Web.Dataset, JS;

type
  TEssentialsCustomNameEditor = class(TCoreWebForm)
    AddButton: TButton;
    cbPageSize: TComboBox;
    DeleteConfirmationMsg: TMessageDlg;
    EssentialsTable: TDBTableControl;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    DataSource: TDataSource;
    procedure AddButtonClick(Sender: TObject);
    procedure cbPageSizeChange(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure EssentialsTableGetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string;
      AElement: TJSHTMLElementRecord);
    procedure DataSourceStateChange(Sender: TObject);
  private
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);
    const RECORD_ID_DELIMITER = ';';
  protected
    FIdField: string;
    FGridPlugin: TGridPlugin;
    [Async]
    procedure EditRecord(ARecordId: string); async;
    [Async]
    procedure DeleteRecord(ARecordId: string); async;
    [Async]
    procedure Save; async;
    function GetDeleteMsg: string;
    procedure RefreshControls(aShow: Boolean);
    function GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
    function ConvertIdFieldsIntoRecords(aIdFields: string): string;
    procedure SetDataSet(aDataSet:TXdataWebDataset);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EssentialsCustomNameEditor: TEssentialsCustomNameEditor;

implementation

uses Essentials.Web.Shared, SMX.Web.Layout.Utils, SMX.webcore.Types,
StrUtils, XData.Web.JsonDataset, Essentials.Web.CustomNames.EditValueForm;

{$R *.dfm}

procedure TEssentialsCustomNameEditor.AddButtonClick(Sender: TObject);
begin
  inherited;
  EditRecord('');
end;

procedure TEssentialsCustomNameEditor.RefreshControls(aShow: Boolean);
begin
  lcPaginator.Visible := aShow;
  lbPaginationInfo.Visible := aShow;
  cbPageSize.Visible := aShow;
end;


procedure TEssentialsCustomNameEditor.Save;
begin
  Await(Boolean, EssentialsManager.CustomNamesManager.SaveChanges);
end;

procedure TEssentialsCustomNameEditor.SetDataSet(aDataSet: TXdataWebDataset);
begin
  DataSource.DataSet := aDataSet;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsCustomNameEditor.AddRowActions(const ARecordId: string;
  AParentElement: TJSHTMLElement);
  procedure EditClick(Sender: TObject);
  begin
    EditRecord(ARecordId);
  end;

  procedure DeleteClick(Sender: TObject);
  begin
    DeleteRecord(ARecordId);
  end;

var
  Span: THTMLSpan;
begin
  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-edit', 'View');
  Span.OnClick := @EditClick;

  Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-trash', 'Delete');
  Span.OnClick := @DeleteClick;
end;

procedure TEssentialsCustomNameEditor.cbPageSizeChange(Sender: TObject);
begin
  inherited;
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

function TEssentialsCustomNameEditor.ConvertIdFieldsIntoRecords(aIdFields: string): string;
var
  idFieldsArr: TArray<string>;
  idField: string;
begin
    idFieldsArr := aIdFields.Split([RECORD_ID_DELIMITER]);
    Result := '';
    for idField in idFieldsArr do
      Result := IfThen(Result <> '', Result + RECORD_ID_DELIMITER, '') + DataSource.DataSet.FieldByName(idField).AsString;
end;

procedure TEssentialsCustomNameEditor.DataSourceStateChange(Sender: TObject);
begin
  inherited;
  AddButton.Enabled := DataSource.DataSet.Active;
end;

procedure TEssentialsCustomNameEditor.DeleteRecord(ARecordId: string);
var {DeleteRecord}
  foundRecord: Boolean;
begin

  if ARecordId.Contains(RECORD_ID_DELIMITER) then
    foundRecord := DataSource.DataSet.Locate(FIdField, GetJSArrayFromRecordIds(ARecordId), [])
  else
    foundRecord := DataSource.Dataset.Locate(FIdField, ARecordId, []);

  if foundRecord and (Await(TModalResult, DeleteConfirmationMsg.ShowDialog(GetDeleteMsg, mtConfirmation, [mbYes, mbNo])) = mrYes) then
  begin
    DataSource.DataSet.Edit;
    DataSource.DataSet.Delete;
    Await(TResolveResults, TXDataWebDataset(DataSource.DataSet).ApplyUpdatesAsync);
  end;
end;

procedure TEssentialsCustomNameEditor.EditRecord(ARecordId: string);
var
  AForm: TCustomNamesEditValue;
begin
  AForm := TCustomNamesEditValue.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    Await(TCustomNamesEditValue, AForm.Load());

    AForm.SetDataSources(DataSource.DataSet);

    if ARecordId = '' then
    begin
      AForm.EditMode := Add;
      DataSource.DataSet.Insert;
    end
    else
    begin
      AForm.EditMode := None;
      DataSource.DataSet.Locate(FIdField, GetJSArrayFromRecordIds(ARecordId), []);
    end;

    AForm.LoadEntityList;

    if Await(TModalResult, AForm.Execute) = mrOK then
    begin
      DataSource.DataSet.FieldByName('EntityClassName').AsString := AForm.EntitySelector.Value;
      DataSource.DataSet.FieldByName('FieldName').AsString := AForm.FieldSelector.Value;
      DataSource.DataSet.Post;
      Await(Save);
    end;
  finally
    FreeAndNil(AForm);
  end;
end;

procedure TEssentialsCustomNameEditor.EssentialsTableGetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: string;
begin
  if ARow = 0 then
    Exit;

  if EssentialsTable.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := ConvertIdFieldsIntoRecords(FIdField);

    if RecordId <> '' then
      AddRowActions(RecordId, AElement.Element)
    else
      AElement.Element.textContent := 'Loading...';
  end;
end;

function TEssentialsCustomNameEditor.GetDeleteMsg: string;
var
  value: string;
begin
  value := DataSource.Dataset.FieldByName('CustomName').AsString;
  Result := Format(DELETE_CONFIRMATION_SCHEMA, [QuotedStr(value)]);
end;

function TEssentialsCustomNameEditor.GetJSArrayFromRecordIds(aRecordIds: string): TJSValueDynArray;
var
  recordIds: TArray<string>;
  i, arrLength: Integer;
begin
  recordIds := aRecordIds.Split([';']);
  arrLength := Length(recordIds);
  SetLength(Result, arrLength);

  for i := 0 to arrLength - 1 do
    Result[i] := recordIds[i];
end;

procedure TEssentialsCustomNameEditor.WebFormCreate(Sender: TObject);
begin
  inherited;
  FIdField := 'EntityClassName;FieldName';
  SetDataSet(EssentialsManager.CustomNamesManager.NamesDataset);
  FGridPlugin := TGridPlugin.Create(EssentialsTable, EssentialsManager.CustomNamesManager.NamesDataset, lcPaginator, lbPaginationInfo,
      TSortPair.Create(1, sdAsc));
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  RefreshControls(False);
end;

procedure TEssentialsCustomNameEditor.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('essentials.customnames.PageInfo');
  AddButton := TButton.Create('essentials.customnames.add.button');
  cbPageSize := TComboBox.Create('essentials.customnames.PageSizeSelect');
  DeleteConfirmationMsg := TMessageDlg.Create('DeleteConfirmationMsg');
  EssentialsTable := TDBTableControl.Create('esssentials.customnames.table');
  lcPaginator := TListControl.Create('essentials.customnames.Pagination');
  DataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  AddButton.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  DeleteConfirmationMsg.BeforeLoadDFMValues;
  EssentialsTable.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 185;
    lbPaginationInfo.Top := 32;
    lbPaginationInfo.Width := 112;
    lbPaginationInfo.Height := 15;
    lbPaginationInfo.Caption := 'No records to display';
    lbPaginationInfo.ElementFont := efCSS;
    lbPaginationInfo.ElementPosition := epIgnore;
    lbPaginationInfo.HeightStyle := ssAuto;
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthStyle := ssAuto;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    AddButton.SetParentComponent(Self);
    AddButton.Name := 'AddButton';
    AddButton.Left := 72;
    AddButton.Top := 296;
    AddButton.Width := 96;
    AddButton.Height := 25;
    AddButton.Caption := 'Add';
    AddButton.ChildOrder := 7;
    AddButton.ElementClassName := 'btn btn-light';
    AddButton.ElementFont := efCSS;
    AddButton.ElementPosition := epIgnore;
    AddButton.HeightStyle := ssAuto;
    AddButton.HeightPercent := 100.000000000000000000;
    AddButton.WidthStyle := ssAuto;
    AddButton.WidthPercent := 100.000000000000000000;
    SetEvent(AddButton, Self, 'OnClick', 'AddButtonClick');
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 33;
    cbPageSize.Top := 29;
    cbPageSize.Width := 81;
    cbPageSize.Height := 23;
    cbPageSize.ElementClassName := 'form-select';
    cbPageSize.ElementFont := efCSS;
    cbPageSize.ElementPosition := epIgnore;
    cbPageSize.HeightStyle := ssAuto;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.Text := '10';
    cbPageSize.WidthStyle := ssAuto;
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    DeleteConfirmationMsg.SetParentComponent(Self);
    DeleteConfirmationMsg.Name := 'DeleteConfirmationMsg';
    DeleteConfirmationMsg.Left := 33;
    DeleteConfirmationMsg.Top := 252;
    DeleteConfirmationMsg.Width := 24;
    DeleteConfirmationMsg.Height := 24;
    DeleteConfirmationMsg.ElementClassName := 'PopUpForm';
    DeleteConfirmationMsg.Buttons := [];
    DeleteConfirmationMsg.Opacity := 0.200000000000000000;
    DeleteConfirmationMsg.Title := 'Delete';
    EssentialsTable.SetParentComponent(Self);
    EssentialsTable.Name := 'EssentialsTable';
    EssentialsTable.Left := 72;
    EssentialsTable.Top := 83;
    EssentialsTable.Width := 505;
    EssentialsTable.Height := 193;
    EssentialsTable.HeightStyle := ssAuto;
    EssentialsTable.WidthStyle := ssAuto;
    EssentialsTable.BorderColor := clSilver;
    EssentialsTable.ChildOrder := 3;
    EssentialsTable.ElementFont := efCSS;
    EssentialsTable.ElementHeaderClassName := 'thead-light';
    EssentialsTable.ElementPosition := epIgnore;
    EssentialsTable.ElementTableClassName := 'table table-striped table-bordered  table-hover';
    EssentialsTable.Footer.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Footer.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Footer.DropDownElementClassName := 'form-control';
    EssentialsTable.Footer.InputElementClassName := 'form-control';
    EssentialsTable.Footer.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Footer.LinkElementClassName := 'link-secondary';
    EssentialsTable.Footer.ListElementClassName := 'pagination';
    EssentialsTable.Footer.ListItemElementClassName := 'page-item';
    EssentialsTable.Footer.ListLinkElementClassName := 'page-link';
    EssentialsTable.Header.ButtonActiveElementClassName := 'btn btn-primary';
    EssentialsTable.Header.ButtonElementClassName := 'btn btn-light';
    EssentialsTable.Header.DropDownElementClassName := 'form-control';
    EssentialsTable.Header.InputElementClassName := 'form-control';
    EssentialsTable.Header.LinkActiveElementClassName := 'link-primary';
    EssentialsTable.Header.LinkElementClassName := 'link-secondary';
    EssentialsTable.Header.ListElementClassName := 'pagination';
    EssentialsTable.Header.ListItemElementClassName := 'page-item';
    EssentialsTable.Header.ListLinkElementClassName := 'page-link';
    SetEvent(EssentialsTable, Self, 'OnGetCellChildren', 'EssentialsTableGetCellChildren');
    EssentialsTable.Columns.Clear;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'EntityClassName';
      Title := 'Entity';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'FieldName';
      Title := 'Field';
    end;
    with EssentialsTable.Columns.Add do
    begin
      DataField := 'CustomName';
      Title := 'Custom Name';
    end;
    with EssentialsTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    EssentialsTable.DataSource := DataSource;
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 153;
    lcPaginator.Top := 354;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightStyle := ssAuto;
    lcPaginator.WidthStyle := ssAuto;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.ChildOrder := 3;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementFont := efCSS;
    lcPaginator.ElementPosition := epIgnore;
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Items.Clear;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 0';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 1';
    end;
    with lcPaginator.Items.Add do
    begin
      ItemClassName := 'page-item';
      LinkClassName := 'page-link';
      Text := 'Item 2';
    end;
    lcPaginator.Style := lsPagination;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    SetEvent(DataSource, Self, 'OnStateChange', 'DataSourceStateChange');
    DataSource.Left := 528;
    DataSource.Top := 288;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    AddButton.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    DeleteConfirmationMsg.AfterLoadDFMValues;
    EssentialsTable.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
  end;
end;

end.
